import React from 'react';
import { StyledFlexBetweenH } from '@goodfynd/styles';
import { Text } from '@goodfynd/ui';

import {
  useOrdersOverview,
  useOrdersOverviewDispatch,
} from '../orders-overview-context/OrdersOverviewProvider';

import { StyledCard, StyledDateRangeFilter } from './styles';
import type { OverviewCardProps } from './types';

import classes from './OverviewCard.module.css';

export function OverviewCard({
  children,
  contentCss,
  headerCss,
  showDateFilter = true,
  title,
  titleRight,
  ...props
}: OverviewCardProps) {
  const { dateEnd: end, dateStart: start } = useOrdersOverview();
  const { changeDateRange } = useOrdersOverviewDispatch();
  return (
    <StyledCard {...props}>
      <StyledFlexBetweenH
        css={{
          alignItems: 'center',
          gap: 12,
          ...headerCss,
        }}
      >
        <Text as="subhead1">{title}</Text>

        {titleRight ||
          (showDateFilter && (
            <StyledDateRangeFilter
              className="filter"
              onChange={(value) => changeDateRange(value)}
              showInfinity={false}
              usePresets
              value={{ end, start } as IntervalDates}
            />
          ))}
      </StyledFlexBetweenH>

      <div className={classes.content} style={contentCss}>
        {children}
      </div>
    </StyledCard>
  );
}
